import { Reducer } from 'redux';
import { HttpRequestStatus } from '../../../../model/enums/httpRequestStatus';
import { PersonUpdateProfileActionTypes, PersonUpdateProfileState } from './types';

export const initialState: PersonUpdateProfileState = {
    status: HttpRequestStatus.NOOP,
    profileUpdate: undefined,
    error: undefined
};

const reducer: Reducer<PersonUpdateProfileState> = (state = initialState, action): PersonUpdateProfileState => {
    switch (action.type) {
        case PersonUpdateProfileActionTypes.PERSON_UPDATE_PROFILE_REQUEST: {
            return { ...state, status: HttpRequestStatus.ONGOING, profileUpdate: undefined, error: undefined };
        }
        case PersonUpdateProfileActionTypes.PERSON_UPDATE_PROFILE_SUCCESS: {
            return { ...state, status: HttpRequestStatus.SUCCESS, profileUpdate: action.payload, error: undefined };
        }
        case PersonUpdateProfileActionTypes.PERSON_UPDATE_PROFILE_ERROR: {
            return { ...state, status: HttpRequestStatus.ERROR, error: action.payload };
        }
        case PersonUpdateProfileActionTypes.PERSON_UPDATE_PROFILE_RESET_STATE: {
            return { ...initialState };
        }
        default: {
            return state;
        }
    }
};

export { reducer as personUpdateProfileReducer };
